<template>
	<div class="marketing-copy-page">
		<!-- 导航栏：统一风格 -->
		<div class="custom-nav-bar" v-if="currentPlatform !== 'weixin'">
			<div v-if="showWebBackBtn" class="back-btn" @click="onBack">
				<img src="@/assets/back.svg" class="back-icon" />
			</div>
			<div class="nav-title">营销文案</div>
		</div>

		<!-- 主体区域：白色背景+撑满剩余高度+精准padding -->
		<div class="page-body">
			<!-- 顶部横向图片容器：撑满宽度+平分间距+最左最右0边距+底部对齐 -->
			<div class="top-img-container">
				<div class="img-item" @click="goHB">
					<img src="@/assets/aihb.png" class="item-img" />
					<!-- 文字容器：底部对齐+两行文字 -->
					<div class="text-wrapper">
						<div class="text-line1">AI海报</div>
						<div class="text-line2">智能匹配风格</div>
					</div>
				</div>
				<div class="img-item" @click="goBJ">
					<img src="@/assets/aibj.png" class="item-img" />
					<div class="text-wrapper">
						<div class="text-line1">AI笔记</div>
						<div class="text-line2">贴合场景需求</div>
					</div>
				</div>
				<div class="img-item" @click="goVd">
					<img src="@/assets/aisp.png" class="item-img" />
					<div class="text-wrapper">
						<div class="text-line1">AI视频</div>
						<div class="text-line2">打造个人IP</div>
					</div>
				</div>
			</div>

			<div class="history-title">我的作品</div>
			<div class="history-line"></div>
			<div class="history-option-box">
				<div class="option-item" :class="{ active: activeOption === 1 }" @click="selectOption(1)">
					AI海报
				</div>
				<div class="option-item" :class="{ active: activeOption === 2 }" @click="selectOption(2)">
					AI笔记
				</div>
				<div class="option-item" :class="{ active: activeOption === 3 }" @click="selectOption(3)">
					AI视频
				</div>
			</div>

			<div class="history-content-box" ref="contentBox">
				<!-- 有数据时显示列表 -->
				<div class="record-list" v-if="recordList.length > 0 && activeOption == 3">
					<div class="video-item" v-for="(item, index) in recordList" :key="index"
						@click="goCreationDetail(item)">
						<div class="videoTime">
							{{ formattedTime(item.videoTime) }}
						</div>
						<img :src="item.fileImageUrl" class="video-img" v-if="item.fileImageUrl" />
					</div>
				</div>
				<div v-else-if="imgList.length > 0 && activeOption == 1">
					<div class="record-list">
						<div class="record-item" v-for="(item, index) in imgList" :key="index">
							<img :src="getFirstUrl(item.imageUrls)" class="record-img" @click="goImage(item)" />
						</div>
					</div>
					<div class="load-tip" v-if="activeOption === 1 && !posterHasMore && imgList.length > 0">
						没有更多数据了
					</div>
				</div>

				<div v-else-if="textList.length > 0 && activeOption == 2">
					<div class="text-list-container">
						<!-- 遍历对象数组，item是包含title/content的完整对象 -->
						<div class="text-item" v-for="(item, index) in textList" :key="index">
							<!-- 显示title，添加点击事件并传入当前item -->
							<div class="text-content" @click="goNoteDetail(item)">
								{{ item.title || "无标题" }}
								<!-- 空值兜底 -->
							</div>
						</div>
					</div>
					<div class="load-tip" v-if="activeOption === 2 && !noteHasMore && textList.length > 0">
						没有更多数据了
					</div>
				</div>
				<div class="load-tip" v-else-if="isLoading">加载中...</div>

				<!-- 无数据时显示空状态（通过height:100%居中） -->
				<div class="empty-state" v-else>
					<img src="@/assets/nodata.png" class="empty-img" />
					<div class="empty-text">暂无记录</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		historyImg,
		historyNote,
		pageTalkingVideo
	} from "@/api";
	export default {
		name: "MarketingCopyPage",
		data() {
			return {
				// 选中的选项索引，默认1（AI海报）
				activeOption: 1,
				// 分页配置
				pageSize: 20, // 每页条数
				// AI海报分页
				posterPageNumber: 1,
				posterHasMore: true,
				// AI笔记分页
				notePageNumber: 1,
				noteHasMore: true,
				// AI视频分页（暂不处理）
				videoPageNumber: 1,
				videoHasMore: true,
				// 列表数据
				imgList: [],
				textList: [],
				recordList: [],
				// 加载状态（防止重复请求）
				isLoading: false,
				showWebBackBtn: false,
				currentPlatform: '',
				popstateListener: null,
			};
		},
		// beforeRouteLeave(to, from, next) {
		//   // 路由离开前注销popstate监听
		//   if (this.popstateListener) {
		// 	  console.log("beforeRouteLeave注销了popstate")
		//     window.removeEventListener('popstate', this.popstateListener);
		//     this.popstateListener = null; // 清空引用，避免重复注销
		//   }
		//   next();
		// },
		// activated() {
		//   // 页面被缓存后重新激活时，重新注册popstate监听（需页面配置keep-alive）
		//   if (this.showWebBackBtn && !this.popstateListener) {
		//     this.popstateListener = (e) => {
		//       e.preventDefault();
		//       history.pushState(null, null, window.location.href);
		//       console.log('仅阻止dashboard页面的浏览器默认回退');
		//     };
		// 	console.log("activated添加了popstate")
		//     window.addEventListener('popstate', this.popstateListener);
		//     history.pushState(null, null, window.location.href);
		//   }
		//   // 重新监听滚动（防止缓存后滚动监听失效）
		//   this.listenScroll();
		// },
		// deactivated() {
		//   // 页面被缓存隐藏时，临时注销监听
		//   if (this.popstateListener) {
		// 	  console.log("deactivated注销了popstate")
		//     window.removeEventListener('popstate', this.popstateListener);
		//     this.popstateListener = null;
		//   }
		//   const contentBox = this.$refs.contentBox;
		//   if (contentBox) {
		//     contentBox.removeEventListener('scroll', this.loadMore);
		//   }
		// },
		mounted() {
			document.title = "营销文案";
			// const searchParams = new URLSearchParams(window.location.search);
			// const token = searchParams.get('token');
			// const currentMode = searchParams.get('mode') || '';
			// this.currentPlatform = searchParams.get('platform') || '';
			const currentMode = sessionStorage.getItem('h5_uni_mode');
			this.currentPlatform = sessionStorage.getItem('h5_uni_platform');
			this.showWebBackBtn = currentMode === 'fullscreen-web';
			console.log("取到的mode ", currentMode)
			// if (this.showWebBackBtn) {
			// 	if (this.popstateListener) {
			// 		console.log("mounted注销了popstate")
			// 	      window.removeEventListener('popstate', this.popstateListener);
			// 	}
			// 	this.popstateListener = (e) => {
			// 		e.preventDefault();
			// 		history.pushState(null, null, window.location.href);
			// 		console.log('仅阻止dashboard页面的浏览器默认回退');
			// 	};
			// 	console.log("mounted添加了popstate")
			// 	window.addEventListener('popstate', this.popstateListener);
			// 	history.pushState(null, null, window.location.href);
			// }

			// 加载uni SDK
			if (['weixin', 'alipay', 'app'].includes(this.currentPlatform) && !window.uni) {
				const script = document.createElement('script');
				script.src = 'https://unpkg.com/@dcloudio/uni-webview-js-sdk@3.0.0/dist/uni.webview.1.5.2.js';
				document.head.appendChild(script);
			}
			// if (token) {
			// 	sessionStorage.setItem('token', token);
			// 	console.log('token 已存入 sessionStorage:', token);
			// } else {
			// 	//sit
			// 	const defaultToken =
			// 		'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOjMzNzc1OTM0ODM5MzYxOTQ1NiwidGVuYW50SWQiOjAsImV4cCI6MTc2OTY3NDkxMX0.vHj2LY-ES1teOeKHx39vPzLwx9rG5xuupFUHlP1jX6s';
			// 	// const defaultToken =
			// 	// 	'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOjM0NjQ4NTYwOTcxNDQzODE0NCwidGVuYW50SWQiOjAsImV4cCI6MTc2NjQ3NzQ1M30.Ct9VPptj59_-vAorpAwQM-d8J6cD8HH371OiQLmbgaI';
			// 	sessionStorage.setItem('token', defaultToken);
			// 	console.log('默认token已存入sessionStorage');
			// }
			this.gethistoryImg();
			// 监听滚动事件
			this.listenScroll();
		},
		beforeDestroy() {
			const contentBox = this.$refs.contentBox;
			if (contentBox) {
				contentBox.removeEventListener('scroll', this.loadMore);
			}

			// if (this.popstateListener) {
			// 	console.log("beforeDestroy注销了popstate")
			//     window.removeEventListener('popstate', this.popstateListener);
			//     this.popstateListener = null;
			//   }
		},
		methods: {
			goImage(item) {
				let urlArray = [];
				// if (item?.imageUrls && typeof item.imageUrls === 'string') {
				// 	// 去除首尾空格 → 按逗号分割 → 过滤空字符串（处理多个逗号/首尾逗号）
				// 	urlArray = item.urls.trim().split(',').filter(url => url.trim() !== '');
				// 	// 对每个URL再trim，避免单个URL带空格（如 " url1 , url2 " → ["url1", "url2"]）
				// 	urlArray = urlArray.map(url => url.trim());
				// }
				if(item?.imageUrls)
				{
					urlArray = item.imageUrls
				}
				this.$router.push({
					path: 'GeneratedPosterPage',
					query: {
						posterUrls: JSON.stringify(urlArray) // 数组转字符串传递
					}
				});
			},
			getFirstUrl(urlStr) {
				// 1. 处理空值（null/undefined/空字符串）
				// if (!urlStr || typeof urlStr !== 'string') {
				// 	return ''; // 返回空字符串避免img标签src报错
				// }
				// // 2. 去除首尾空格，再按逗号分割成数组
				// const urlArray = urlStr.trim().split(',');
				// // 3. 过滤掉空字符串（处理多个逗号、首尾逗号的情况），取第一个有效URL
				// const validUrls = urlArray.filter(url => url.trim() !== '');
				// // 4. 返回第一个有效URL，无则返回空
				// return validUrls.length > 0 ? validUrls[0].trim() : '';
				if(urlStr && urlStr.length){
					return urlStr[0]
				}else{
					return ''
				}
			},
			async gethistoryImg() {
				if (!this.posterHasMore || this.isLoading) return;
				this.isLoading = true;
				try {
					const data = await historyImg({
						pageNum: this.posterPageNumber,
						pageSize: this.pageSize
					});
					console.log("AI海报数据", data);
					// 关键：获取总条数 + 兜底
					const totalRow = data?.totalRow || 0;
					if (data && Array.isArray(data.records)) {
						// 拼接数据
						if (this.posterPageNumber === 1) {
							this.imgList = data.records;
						} else {
							this.imgList = [...this.imgList, ...data.records];
						}
						// 新判断逻辑：已加载数量 < 总条数 → 还有更多
						this.posterHasMore = this.imgList.length < totalRow;
						console.log("123123", this.posterHasMore, this.imgList.length, totalRow)
					} else {
						this.posterHasMore = false;
					}
				} catch (error) {
					console.error("AI海报获取失败：", error);
					this.posterHasMore = false;
				} finally {
					this.isLoading = false;
				}
			},
			async gethistoryNote() {
				if (!this.noteHasMore || this.isLoading) return;
				this.isLoading = true;
				try {
					const data = await historyNote({
						pageNumber: this.notePageNumber,
						pageSize: this.pageSize
					});
					console.log("AI笔记数据", data);
					// 关键：获取总条数 + 兜底
					const totalRow = data?.totalRow || 0;
					if (data && Array.isArray(data.records)) {
						// 拼接数据
						if (this.notePageNumber === 1) {
							this.textList = data.records;
						} else {
							this.textList = [...this.textList, ...data.records];
						}
						// 新判断逻辑：已加载数量 < 总条数 → 还有更多
						this.noteHasMore = this.textList.length < totalRow;
					} else {
						this.noteHasMore = false;
					}
				} catch (error) {
					console.error("AI笔记获取失败：", error);
					this.noteHasMore = false;
				} finally {
					this.isLoading = false;
				}
			},
			async getRecordList() {
				if (!this.videoHasMore || this.isLoading) return;
				this.isLoading = true;
				try {
					const data = await pageTalkingVideo({
						pageNumber: this.videoPageNumber,
						pageSize: this.pageSize,
						createStatus: 2,
					});
					console.log("AI笔记数据", data);
					// 关键：获取总条数 + 兜底
					const totalRow = data?.totalRow || 0;
					if (data && Array.isArray(data.records)) {
						// 拼接数据
						if (this.videoPageNumber === 1) {
							this.recordList = data.records;
						} else {
							this.recordList = [...this.recordList, ...data.records];
						}
						// 新判断逻辑：已加载数量 < 总条数 → 还有更多
						this.videoHasMore = this.recordList.length < totalRow;
					} else {
						this.videoHasMore = false;
					}
				} catch (error) {
					console.error("AI笔记获取失败：", error);
					this.videoHasMore = false;
				} finally {
					this.isLoading = false;
				}
			},
			loadMore() {
				// 正在加载/无更多数据，直接返回
				if (this.isLoading) return;
				switch (this.activeOption) {
					case 1:
						if (this.posterHasMore) {
							this.posterPageNumber++;
							this.gethistoryImg();
						}
						break;
					case 2:
						if (this.noteHasMore) {
							this.notePageNumber++;
							this.gethistoryNote();
						}
						break;
					case 3: // AI视频暂不处理
						if (this.videoHasMore) {
							this.videoPageNumber++;
							this.getRecordList();
						}
						break;
				}
			},
			// 5. 监听滚动到底部
			listenScroll() {
				const contentBox = this.$refs.contentBox;
				if (!contentBox) return;
				contentBox.addEventListener("scroll", () => {
					// 滚动到底部的判断：滚动高度 + 可视高度 >= 总高度 - 100（提前加载）
					const {
						scrollTop,
						clientHeight,
						scrollHeight
					} = contentBox;
					if (scrollTop + clientHeight >= scrollHeight - 100) {
						this.loadMore();
					}
				});
			},
			// 返回按钮逻辑
			onBack(e) {
				e.preventDefault();
				e.stopPropagation();

				this.waitForSDK(() => {
					if (this.currentPlatform === "h5") {
						window.parent.postMessage({
								type: "BACK_TO_UNIAPP",
							},
							"*",
						);
					} else {
						uni.postMessage({
							data: {
								type: "BACK_TO_UNIAPP",
							},
						});
						if (this.currentPlatform === "weixin" && window.wx) {
							wx.miniProgram.navigateBack({
								delta: 1,
							});
						}
					}
				});
			},
			waitForSDK(cb) {
				if (["weixin", "alipay", "app"].includes(this.currentPlatform)) {
					if (window.uni) {
						cb();
					} else {
						setTimeout(() => this.waitForSDK(cb), 100);
					}
				} else {
					cb();
				}
			},
			goNoteDetail(item) {
				if (!item) return;
				this.$router.push({
					path: "aiTextDetail", // 需在路由配置中注册该页面
					query: {
						titles: JSON.stringify([item.title || ""]), // 数组转JSON字符串传递
						content: item.content,
					},
				});
			},
			goHB() {
				this.$router.push({
					path: "aiPoster",
				});
			},
			goBJ() {
				this.$router.push({
					path: "aiText",
				});
			},
			goVd() {
				sessionStorage.setItem('formPage', 'home');
				this.$router.push({
					path: "aiVideo",
				});
			},
			selectOption(index) {
				console.log(index, "index");
				this.activeOption = index;
				// 重置加载状态
				this.isLoading = false;
				// 根据选项重置对应数据和分页
				switch (index) {
					case 1: // AI海报
						this.imgList = [];
						this.posterPageNumber = 1;
						this.posterHasMore = true;
						this.gethistoryImg(); // 重新拉取第一页
						break;
					case 2: // AI笔记
						this.textList = [];
						this.notePageNumber = 1;
						this.noteHasMore = true;
						this.gethistoryNote(); // 重新拉取第一页
						break;
					case 3: // AI视频（暂不处理）
						this.recordList = [];
						this.videoPageNumber = 1;
						this.videoHasMore = true;
						this.getRecordList();
						break;
				}
			},
			goCreationDetail(item) {
								sessionStorage.setItem('formPage', 'home');

				this.$router.push({
					path: "creationDetail",
					query: {
						id: item.id,
						formPath: 'home'
					},
				});
			},
			formattedTime(value) {
               const minutes = Math.floor(value / 60).toString().padStart(2, "0");
               const seconds = (value % 60).toString().padStart(2, "0");
               return `${minutes}:${seconds}`;
           },
		},
	};
</script>

<style scoped>
	/* 页面基础布局：纵向排列+最小高度100vh */
	.marketing-copy-page {
		min-height: 100vh;
		min-height: 100dvh;
		height: 100vh;
		height: 100dvh;
		/* 新增：固定视口高度，禁止页面整体滚动 */
		background: #f5f6f8;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		overflow: hidden !important;
		/* 强制禁止整体滚动 */
		touch-action: none;
		/* 禁止触摸滚动行为（移动端） */
	}

	/* 导航栏：完全复用原有统一风格 */
	.custom-nav-bar {
		width: 100vw;
		height: 11.7333vw;
		background-image: linear-gradient(90deg, #e7f2fa 0%, #dbe2f1 100%);
		box-shadow: 0px 0.1333vw 0px 0px rgba(97, 182, 255, 0.3);
		position: relative;
		z-index: 999;
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		flex-shrink: 0;
	}

	.back-btn {
		width: 6.4vw;
		height: 6.4vw;
		position: absolute;
		left: 2.6667vw;
		top: 50%;
		transform: translateY(-50%);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.back-icon {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.nav-title {
		font-family: SourceHanSansSC-Medium;
		font-size: 4.8vw;
		color: #000000;
		letter-spacing: 0.1333vw;
		text-align: center;
		line-height: 11.7333vw;
		font-weight: 500;
	}

	/* 主体区域：白色背景+撑满剩余高度+精准padding（左右32px 上下40px） */
	.page-body {
		padding: 5.3333vw 4.2667vw;
		/* 上40px 下40px 左32px 右32px */
		box-sizing: border-box;
		background: #ffffff;
		flex: 1;
		/* 撑满除导航外所有屏幕高度 */
		min-height: 0;
		/* 兼容弹性布局，防止内容溢出 */
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	/* 顶部横向图片容器：撑满宽度+平分间距+最左最右0边距+底部对齐 */
	.top-img-container {
		width: 100%;
		height: auto;
		/* 高度自动 */
		display: flex;
		align-items: flex-start;
		/* 底部对齐 */
		justify-content: space-between;
		/* 平分间距，最左最右0边距 */
		box-sizing: border-box;
	}

	/* 单个图片项：修复高度为0问题 + relative定位 + padding */
	.img-item {
		width: 29.3333vw;
		/* 220px 容器宽度不变 */
		min-height: 20vw;
		/* 保底高度，适配图片未加载/比例问题 */
		box-sizing: border-box;
		position: relative;
		/* 为文字/图片提供定位参考 */
		padding: 2.6667vw;
		/* 20px padding，文字在该区域内 */
		/* 关键：让容器高度等于图片高度 */
		display: inline-block;
		vertical-align: bottom;
		height: 100%;
	}

	/* 图片样式：绝对定位，撑满容器，不受padding影响 */
	.item-img {
		width: 100%;
		height: auto;
		object-fit: contain;
		display: block;
		position: absolute;
		/* 脱离文档流，不受padding挤压 */
		/* top: 0; */
		left: 0;
		bottom: 0;
		z-index: 1;
		/* 图片在底层 */
		/* 确保图片撑满容器宽度，高度自适应 */
		max-width: 100%;
	}

	/* 文字容器：精准定位到padding底部 + 两行文字4px间距 */
	.text-wrapper {
		position: absolute;
		bottom: 2.6667vw;
		/* 与padding底部对齐（20px） */
		left: 2.6667vw;
		/* 与padding左侧对齐（20px） */
		right: 2.6667vw;
		/* 与padding右侧对齐（20px） */
		z-index: 2;
		/* 文字在图片上方 */
		line-height: 1;
		/* 重置行高，精准控制间距 */
		display: flex;
		flex-direction: column;
		gap: 0.5333vw;
		/* 两行文字间距4px = 0.5333vw */
	}

	/* 第一行文字样式：严格匹配要求 */
	.text-line1 {
		opacity: 0.8;
		font-family: SourceHanSansSC-Medium;
		font-size: 3.2vw;
		/* 24px = 3.2vw */
		color: #333333;
		letter-spacing: 0;
		font-weight: 500;
	}

	/* 第二行文字样式：严格匹配要求 */
	.text-line2 {
		opacity: 0.4;
		font-family: SourceHanSansSC-Regular;
		font-size: 2.4vw;
		/* 18px = 2.4vw */
		color: #333333;
		letter-spacing: 0;
		font-weight: 400;
	}

	.history-title {
		margin-top: 5.3333vw;
		/* 40px = 40/7.5 = 5.3333vw */
		opacity: 0.9;
		font-family: AlimamaShuHeiTi-Bold;
		font-size: 5.3333vw;
		/* 40px = 40/7.5 = 5.3333vw */
		color: #1b3154;
		letter-spacing: -0.128vw;
		/* -0.96px = -0.96/7.5 = -0.128vw */
		font-weight: 700;
	}

	.history-line {
		margin-top: 3.2vw;
		/* 24px = 24/7.5 = 3.2vw */
		width: 100%;
		/* 宽度100% */
		height: 0.2667vw;
		/* 2px = 2/7.5 = 0.2667vw */
		background: #e4e8ec;
		/* 背景色 */
		box-sizing: border-box;
	}

	.history-option-box {
		margin-top: 3.3333vw;
		/* 25px = 25/7.5 = 3.3333vw */
		width: 55.4667vw;
		/* 416px = 416/7.5 = 55.4667vw */
		height: 8vw;
		/* 60px = 60/7.5 = 8vw */
		background-image: linear-gradient(98deg,
				#f0f4ff 0%,
				#f0f4ff 3%,
				#eef9ff 100%);
		border-radius: 1.0667vw;
		/* 8px = 8/7.5 = 1.0667vw */
		padding: 0.5333vw;
		/* 4px = 4/7.5 = 0.5333vw */
		box-sizing: border-box;
		display: flex;
		/* 横向排列子项 */
		justify-content: space-between;
		/* 平分空间 */
	}

	/* 选项子项基础样式 */
	.option-item {
		flex: 1;
		/* 平分父容器宽度 */
		height: 100%;
		/* 撑满父容器高度 */
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 1.0667vw;
		/* 8px = 8/7.5 = 1.0667vw */
		font-family: SourceHanSansSC-Regular;
		font-size: 3.2vw;
		/* 24px = 24/7.5 = 3.2vw */
		color: rgba(0, 0, 0, 0.6);
		letter-spacing: 0;
		text-align: center;
		font-weight: 400;
		box-sizing: border-box;
	}

	/* 选中状态样式 */
	.option-item.active {
		background: #ffffff;
		box-shadow: 0px 0px 0.9333vw 0px rgba(171, 180, 187, 0.34);
		/* 7px = 7/7.5 = 0.9333vw */
		font-family: SourceHanSansSC-Medium;
		font-size: 3.2vw;
		/* 24px = 24/7.5 = 3.2vw */
		color: #000000;
		font-weight: 500;
	}

	.history-content-box {
		margin-top: 5.3333vw;
		width: 100%;
		height: calc(100vh - 74.5332vw);
		height: calc(100dvh - 74.5332vw);
		/* flex: 1; */
		box-sizing: border-box;
		overflow-y: auto;
		/* 仅此处纵向滚动 */
		overflow-x: hidden;
		/* 禁止横向滚动 */
		padding-bottom: 2vw;
		/* 底部留白优化体验 */
		/* 移除居中样式（有数据时不需要居中，空状态单独处理） */
		display: block;
		-webkit-overflow-scrolling: touch;
		/* 保留移动端弹性滚动 */
		scrollbar-width: none;
		/* Firefox 隐藏滚动条 */
		-ms-overflow-style: none;
		/* IE/Edge 隐藏滚动条 */
	}

	.history-content-box::-webkit-scrollbar {
		display: none;
		/* 隐藏滚动条 */
		width: 0;
		height: 0;
	}

	.history-content-box::-webkit-scrollbar-track {
		background: transparent;
	}

	.history-content-box::-webkit-scrollbar-thumb {
		background: transparent;
	}

	/* 无数据状态容器 */
	.empty-state {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100%;
		/* 撑满content-box高度实现居中 */
	}

	/* 无数据图片样式 */
	.empty-img {
		width: 26.6667vw;
		/* 200px = 200/7.5 = 26.6667vw */
		height: 21.3333vw;
		/* 160px = 160/7.5 = 21.3333vw */
		object-fit: contain;
		/* 保持图片比例 */
	}

	/* 无数据文字样式 */
	.empty-text {
		margin-top: 4.2667vw;
		/* 32px = 32/7.5 = 4.2667vw */
		font-family: SourceHanSansSC-Regular;
		font-size: 3.2vw;
		/* 24px = 24/7.5 = 3.2vw */
		color: #c2c2c2;
		text-align: center;
		font-weight: 400;
	}

	.record-list {
		width: calc(100vw - 8.5334vw);
		display: flex;
		flex-wrap: wrap;
		/* 自动换行 */
		justify-content: flex-start;
		/* 横向等分间距 */
		box-sizing: border-box;
	}

	/* 单个记录项容器 */
	.record-item {
		width: 25.6vw;
		/* 192px = 192/7.5 = 25.6vw */
		height: 48vw;
		/* 360px = 360/7.5 = 48vw */
		margin-bottom: 3.2vw;
		margin-left: 2.4444vw;
		margin-right: 2.4444vw;
		flex-shrink: 0;
		/* 24px = 24/7.5 = 3.2vw */
		box-sizing: border-box;
	}

	/* 记录项内图片 */
	.record-img {
		width: 100%;
		/* 宽度占满容器 */
		height: 100%;
		/* 高度自适应（这里用100%撑满容器，也可写auto） */
		object-fit: contain;
		/* 保持图片比例，不拉伸 */
		display: block;
		/* 去除图片默认间隙 */
	}

	.text-list-container {
		width: 100%;
		box-sizing: border-box;
		/* 每个item之间的间距 */
		display: flex;
		flex-direction: column;
		gap: 2.6667vw;
		/* 20px = 20/7.5，item之间上下间距 */
	}

	/* 单个文字字符串容器 */
	.text-item {
		width: 100%;
		/* 宽度占满 */
		height: auto;
		/* 高度自适应 */
		padding: 2.6667vw 3.2vw;
		/* 上下20px(2.6667vw)、左右24px(3.2vw) */
		border-radius: 2.1333vw;
		/* 16px = 16/7.5 */
		background-color: rgba(240, 244, 248, 0.6);
		box-shadow: 0px -0.2667vw 0px 0px rgba(228, 232, 236, 1);
		/* -2px = -0.2667vw */
		box-sizing: border-box;
	}

	/* 文字内容样式 */
	.text-content {
		opacity: 0.8;
		font-family: SourceHanSansSC-regular;
		color: #333333;
		font-weight: 400;
		font-size: 2.9333vw;
		/* 22px = 22/7.5 */
		font-style: normal;
		text-decoration: none;
		text-align: left;
		line-height: 1.5;
		/* 增加行高，提升可读性 */
		word-wrap: break-word;
		/* 自动换行 */
		word-break: break-all;
		/* 兼容长字符串换行 */
	}

	.load-tip {
		text-align: center;
		padding: 2.6667vw 0;
		font-size: 2.6667vw;
		color: #999;
	}

	.video-item {
		width: 25.6vw;
		/* 192px = 192/7.5 = 25.6vw */
		height: 48vw;
		/* 360px = 360/7.5 = 48vw */
		margin-bottom: 3.2vw;
		margin-left: 2.4444vw;
		margin-right: 2.4444vw;
		/* flex-shrink: 0;
  box-sizing: border-box; */
		background-color: #d8d8d8;
		border-radius: 2.1333vw;
		position: relative;
	}

	.video-img {
		width: 100%;
		height: 100%;
		border-radius: 2.1333vw;
		object-fit: cover;
	}

	.videoTime {
		position: absolute;
		left: 1.6vw;
		bottom: 0.8vw;
		color: #ffffff;
		font-weight: 500;
		font-size: 2.666vw;
		line-height: 3.8666vw;
	}
</style>